export default {
  borderGrey: '#111',
  borderLightGrey: '#999',
  primary: '#3F51B5',
  white: '#fff',
  black: "#000",
};
